import OrderTracking from '../../features/OrderTracking';
import OrderComplain from '../../features/OrderComplain';
import ReviewComplain from '../../features/ReviewComplain';
import WarrantyLookup from '../../features/WarrantyLookup/presentation';
import { Redirect } from 'react-router-dom';

export const routes = [
  { path: '/order-tracking/detail', component: OrderTracking, exact: true },
  { path: '/order-tracking', component: OrderTracking, exact: true },
  { path: '/order-tracking/detail/order-complain', component: OrderComplain, exact: true },
  {
    path: '/order-tracking/detail/order-complain/review-complain',
    component: ReviewComplain,
    exact: true,
  },
  { path: '/warranty-lookup', component: WarrantyLookup, exact: true },

  { path: '*', render: () => <Redirect to="/order-tracking" /> },
];
